<template>
  <div id="big-boxes">
    <div class="row" v-if="['Savage Embers', 'Savage Worlds'].includes(ruleset)">
      <div class="col-12 col-md-4 text-center">
        <savage-health></savage-health>
      </div>
      <div class="col-6 col-md-3 text-center">
        <charisma></charisma>
      </div>
      <div class="col-6 col-md text-center">
        <speed>Pace</speed>
      </div>
      <div class="col-6 col-md text-center">
        <parry>Parry</parry>
      </div>
      <div class="col-6 col-md text-center">
        <toughness>Toughness</toughness>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12 col-lg-6 text-center">
        <health></health>
      </div>

      <div class="col text-center">
        <armor-class></armor-class>
      </div>

      <div class="col text-center">
        <perception v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)"></perception>
        <initiative v-else></initiative>
      </div>

      <div class="col text-center">
        <speed></speed>
      </div>
      
    </div>

  </div>
</template>
<script>
import { mapState } from "vuex";
import ArmorClass from "./_ArmorClass.vue";
import Health from "./_Health.vue";
import Initiative from "./_Initiative.vue";
import Perception from "./_Perception.vue";
import Speed from "./_Speed.vue";
import Charisma from "./_Charisma.vue";
import Parry from "./_Parry.vue";
import SavageHealth from "./_SavageHealth.vue";
import Toughness from "./_Toughness.vue";

export default {
  name: "big-boxes",
  components: {
    ArmorClass,
    Health,
    Initiative,
    Perception,
    Speed,
    Charisma,
    Parry,
    SavageHealth,
    Toughness,
  },
  computed: {
    ...mapState({
      ruleset: (state) => state.characters.current.ruleset,
    }),
  },
};
</script>
<style lang="scss">
@import "../../../../assets/_global";

#big-boxes {
  margin-bottom: 0.5em;
}
.big-box {
  .primary {
    font-size: 2.5em;
    line-height: 1.35em;
  }
  .mainline {
    border-bottom: solid 3px $gray-600;
    font-weight: bold;
  }
  .has-toggle {
    display: inline-block;
    font-size: 0.875em;
    margin-bottom: 0em;
    cursor: pointer;
  }
  input[type="text"] {
    font-weight: bold;
    margin: auto;
    text-align: center;
  }
}
</style>
